export default "__VITE_ASSET__CRXXhV9___"